import React from 'react';
import { Grid, InputLabel } from '@material-ui/core';

const TreeTitle = ({ classes, listTitle, listSide, list, data }) => {
  const countFundNode = data => {
    let count = 0;
    data.forEach(node => {
      if (node.fundFamilyNode) {
        count = count + node.funds.length;
      } else count++;
    });

    return count;
  };

  const numberOfFundsAvailable = countFundNode(data);
  const numberOfFundsSelected = countFundNode(list);

  if (listSide === 'left') {
    return (
      <Grid item xs={12} className={classes.itemGrid}>
        <InputLabel className={classes.searchLabel} shrink>
          {listTitle}
        </InputLabel>
      </Grid>
    );
  } else if (listSide === 'right') {
    return (
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={8}>
          <InputLabel className={classes.searchLabel} shrink>
            {listTitle}
          </InputLabel>
        </Grid>
        <Grid item xs={4} className={classes.itemsNumberGrid}>
          <span>{`${numberOfFundsSelected} of ${numberOfFundsAvailable}`}</span>
        </Grid>
      </Grid>
    );
  }
};

export default TreeTitle;
